import { render, staticRenderFns } from "./SidFont.vue?vue&type=template&id=2d837ec0"
import script from "./SidFont.vue?vue&type=script&lang=js"
export * from "./SidFont.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports